import moment, { Moment } from 'moment-timezone';
import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';

import { getShortHumanReadableTimeFromNow } from 'utils/getShortHumanReadableTimeFromNow';

import { getIntervalBasedOnTimeDifference } from './utils/getIntervalBasedOnTimeDifference';

/**
 * A hook that accepts time and interval and returns the relative time from now
 * and updates the value based on the interval. If interval is not passed the
 * hook will calculate the interval based on the difference between the given
 * time and now.
 *
 * @deprecated Only import this if you are working on old structure, otherwise
 *   import the one existing in the new structure.
 */
export function useShortHumanReadableTimer(
  dateTime?: string | number | Moment | null,
  updateInterval?: number,
): string {
  const momentDate = dateTime ? moment(dateTime) : null;
  const [timeFromNow, setTimeFromNow] = useState<string>(
    getShortHumanReadableTimeFromNow(momentDate),
  );

  useInterval(() => {
    setTimeFromNow(getShortHumanReadableTimeFromNow(momentDate));
  }, updateInterval || getIntervalBasedOnTimeDifference(momentDate));

  useEffect(() => {
    setTimeFromNow(getShortHumanReadableTimeFromNow(momentDate));
  }, [momentDate]);

  return timeFromNow;
}
